import { Cpu, Globe } from "lucide-react";

const GAMES = {
  STAR_ATLAS_UE5: {
    id: "STAR_ATLAS_UE5",
    name: "Star Atlas - UE5",
    shortName: "UE5",
    icon: Cpu,
    color: "primary",
    bgActive: "bg-primary/20",
    borderActive: "border-primary",
    textActive: "text-primary",
  },
  STAR_ATLAS_HOLOSIM: {
    id: "STAR_ATLAS_HOLOSIM",
    name: "Star Atlas - Holosim",
    shortName: "Holosim",
    icon: Globe,
    color: "cyan",
    bgActive: "bg-cyan-500/20",
    borderActive: "border-cyan-500",
    textActive: "text-cyan-400",
  }
};

export function GameSelector({ selectedGame, onGameChange, size = "default" }) {
  const sizeClasses = {
    default: "p-4",
    large: "p-5 md:p-6",
    small: "p-3"
  };
  
  const iconSizes = {
    default: "w-6 h-6",
    large: "w-8 h-8",
    small: "w-5 h-5"
  };
  
  const textSizes = {
    default: "text-sm",
    large: "text-base md:text-lg",
    small: "text-xs"
  };
  
  const subtextSizes = {
    default: "text-xs",
    large: "text-sm",
    small: "text-[10px]"
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
      {Object.values(GAMES).map((game) => {
        const isSelected = selectedGame === game.id;
        const Icon = game.icon;
        
        return (
          <button
            key={game.id}
            type="button"
            onClick={() => onGameChange(game.id)}
            className={`${sizeClasses[size]} rounded-sm border text-left transition-all ${
              isSelected
                ? `${game.bgActive} ${game.borderActive} ${game.textActive}`
                : "bg-card border-border/40 hover:border-border text-muted-foreground hover:text-foreground"
            }`}
            data-testid={`game-${game.id.toLowerCase().replace(/_/g, '-')}-btn`}
          >
            <div className="flex items-center gap-3 md:gap-4">
              <Icon className={`${iconSizes[size]} ${isSelected ? game.textActive : "text-muted-foreground"}`} />
              <div>
                <p className={`font-heading font-bold uppercase tracking-wider ${textSizes[size]}`}>
                  {game.name}
                </p>
                <p className={`${subtextSizes[size]} ${isSelected ? 'opacity-80' : 'text-muted-foreground'}`}>
                  {game.id === "STAR_ATLAS_UE5" ? "3D Unreal Engine game" : "Browser-based fleet management RPG"}
                </p>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}

export function GameBadge({ game, size = "default" }) {
  const gameConfig = GAMES[game] || GAMES.STAR_ATLAS_UE5;
  const Icon = gameConfig.icon;
  
  const sizeClasses = {
    default: "text-[10px] px-2 py-0.5",
    large: "text-xs px-2.5 py-1",
    small: "text-[9px] px-1.5 py-0.5"
  };
  
  const iconSizes = {
    default: "w-3 h-3",
    large: "w-3.5 h-3.5",
    small: "w-2.5 h-2.5"
  };

  return (
    <span className={`font-mono ${sizeClasses[size]} ${gameConfig.bgActive} ${gameConfig.textActive} border ${gameConfig.borderActive}/30 rounded-sm flex items-center gap-1`}>
      <Icon className={iconSizes[size]} />
      {gameConfig.shortName}
    </span>
  );
}

export { GAMES };
export default GameSelector;
